const planetOrbitSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="48.641px" height="35.513px" viewBox="0 0 48.641 35.513" enable-background="new 0 0 48.641 35.513" xml:space="preserve">
<g>
	<path fill="#E22A72" d="M27.891,1.829l0.925,0.767l0.192,1.186c0.029,0.146,0.107,0.235,0.235,0.271
		c0.128,0.034,0.273,0.005,0.341-0.114l0.766-0.925l1.186-0.192c0.145-0.029,0.235-0.108,0.27-0.235
		c0.035-0.128,0.006-0.274-0.113-0.341L30.736,1.47l-0.192-1.187c-0.029-0.146-0.107-0.235-0.236-0.27
		c-0.127-0.035-0.273-0.006-0.339,0.114l-0.768,0.925l-1.187,0.192c-0.145,0.028-0.235,0.107-0.27,0.235
		C27.743,1.616,27.771,1.762,27.891,1.829z"/>
	<path fill="#E22A72" d="M43.337,5.066l0.925,0.767l0.192,1.186c-0.018,0.064,0.083,0.195,0.211,0.229
		c0.128,0.036,0.273,0.006,0.34-0.114l0.767-0.924l1.187-0.192c0.146-0.028,0.235-0.107,0.27-0.235
		c0.035-0.127,0.006-0.274-0.113-0.341l-0.925-0.768L45.99,3.521c-0.038-0.113-0.107-0.235-0.236-0.271
		c-0.127-0.035-0.273-0.006-0.339,0.113l-0.767,0.925l-1.186,0.192c-0.146,0.03-0.236,0.109-0.271,0.236
		C43.197,4.822,43.226,4.967,43.337,5.066z"/>
	<path fill="#E22A72" d="M44.711,10.375l0.924,0.767l0.193,1.187c0.029,0.145,0.107,0.234,0.236,0.27
		c0.127,0.036,0.273,0.007,0.34-0.113l0.768-0.924l1.185-0.194c0.146-0.028,0.236-0.106,0.271-0.235
		c0.035-0.127,0.006-0.273-0.114-0.34l-0.923-0.765l-0.193-1.187c-0.038-0.113-0.148-0.213-0.244-0.239
		c-0.129-0.034-0.274-0.005-0.341,0.114l-0.767,0.925L44.859,9.83c-0.146,0.029-0.236,0.109-0.27,0.236
		C44.554,10.194,44.624,10.317,44.711,10.375z"/>
	<g>
		<g>
			<g>
				<path fill="#EC2079" d="M3.882,20.17c-0.333-0.228-0.787-0.143-1.014,0.19l-0.005,0.008c-0.229,0.332-0.143,0.785,0.19,1.014
					c0.068,0.048,0.144,0.082,0.22,0.102c0.291,0.08,0.613-0.028,0.793-0.291l0.006-0.009C4.298,20.852,4.213,20.397,3.882,20.17z"
					/>
			</g>
		</g>
		<g>
			<g>
				<path fill="#EC2079" d="M41.616,8.211c-0.876-1.532-2.337-2.646-4.339-3.311c-1.86-0.618-4.104-0.817-6.67-0.597
					c-0.401,0.034-0.699,0.389-0.663,0.79c0.035,0.401,0.388,0.697,0.789,0.662c4.723-0.405,8.229,0.752,9.618,3.18
					c1.621,2.834,0.274,7.212-3.514,11.67c0.146-2.943-0.549-5.87-2.046-8.488c-2.07-3.618-5.425-6.214-9.447-7.309
					c-4.022-1.093-8.229-0.557-11.847,1.513c-3.617,2.068-6.214,5.423-7.309,9.446c-1.062,3.903-0.587,7.983,1.337,11.529
					c0.002,0.004,0.004,0.009,0.007,0.013c0.056,0.102,0.111,0.203,0.169,0.305c1.498,2.618,3.672,4.701,6.282,6.068
					c-0.954,0.166-1.889,0.277-2.794,0.333c-4.489,0.273-7.702-0.871-9.048-3.221c-0.977-1.708-0.901-3.979,0.217-6.565
					c0.16-0.369-0.01-0.798-0.379-0.958c-0.37-0.16-0.799,0.009-0.959,0.379c-1.307,3.025-1.358,5.747-0.144,7.868
					c0.968,1.693,2.659,2.876,4.932,3.495c1.563,0.425,3.402,0.583,5.47,0.457c1.616-0.098,3.315-0.367,5.06-0.794
					c0.267,0.088,0.536,0.17,0.81,0.244c4.021,1.095,8.229,0.558,11.847-1.511c3.618-2.07,6.213-5.426,7.308-9.446
					c0.075-0.275,0.141-0.551,0.201-0.827c0.071-0.073,0.141-0.145,0.21-0.217c2.451-2.566,4.216-5.236,5.107-7.719
					C42.775,12.533,42.705,10.115,41.616,8.211z M7.596,16.15c0.141-0.52,0.311-1.023,0.506-1.514
					c2.986-0.564,6.161-1.778,9.211-3.524c0.35-0.2,0.471-0.646,0.271-0.996c-0.2-0.349-0.646-0.47-0.995-0.27
					c-2.552,1.459-5.185,2.527-7.699,3.129c3.091-5.544,9.676-8.5,16.07-6.76c2.367,0.645,4.429,1.855,6.081,3.447
					c-2.485,2.907-5.839,5.607-9.741,7.84c-4.743,2.713-9.686,4.378-14,4.727C6.963,20.263,7.039,18.197,7.596,16.15z
					 M19.173,33.858c2.656-0.881,5.368-2.098,8.011-3.611c2.617-1.497,5.054-3.225,7.177-5.081
					C31.925,31.204,25.613,34.817,19.173,33.858z M26.461,28.981c-3.339,1.911-6.779,3.332-10.056,4.176
					c-2.951-1.072-5.356-3.054-6.983-5.539c4.78-0.352,10.395-2.213,15.622-5.202c0.349-0.2,0.471-0.646,0.27-0.995
					c-0.2-0.351-0.646-0.471-0.995-0.27c-5.308,3.035-11.002,4.864-15.711,5.055c-0.407-0.811-0.738-1.661-0.985-2.54
					c4.476-0.4,9.551-2.123,14.401-4.896c3.991-2.284,7.436-5.05,10.019-8.034c1.512,1.795,2.569,3.95,3.052,6.265
					c-2.115,2.589-4.957,5.095-8.238,7.264c-0.336,0.221-0.428,0.674-0.206,1.009c0.102,0.154,0.251,0.257,0.416,0.303
					c0.195,0.052,0.412,0.024,0.594-0.096c2.977-1.967,5.609-4.208,7.698-6.547c0.077,1.147,0.014,2.318-0.203,3.49
					C32.747,24.84,29.755,27.096,26.461,28.981z"/>
			</g>
		</g>
		<g>
			<g>
				<path fill="#EC2079" d="M26.117,8.738c-0.275-0.295-0.736-0.31-1.03-0.036c-1.922,1.797-4.157,3.43-6.645,4.854
					c-0.349,0.199-0.471,0.646-0.271,0.995c0.1,0.174,0.261,0.293,0.442,0.341c0.179,0.05,0.378,0.031,0.553-0.069
					c2.586-1.48,4.913-3.18,6.917-5.055C26.376,9.491,26.392,9.031,26.117,8.738z"/>
			</g>
		</g>
		<g>
			<g>
				<path fill="#EC2079" d="M25.373,26.061c-0.2-0.35-0.645-0.471-0.995-0.271l-0.006,0.003c-0.35,0.201-0.471,0.646-0.271,0.995
					c0.101,0.175,0.262,0.292,0.441,0.341c0.181,0.049,0.379,0.03,0.554-0.07c0,0,0.006-0.003,0.007-0.003
					C25.451,26.855,25.573,26.408,25.373,26.061z"/>
			</g>
		</g>
	</g>
</g>
</svg>

`;

export default planetOrbitSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/planetOrbitSVG.js